export function formatDateTime(value?: string | Date | null): string {
  if (!value) {
    return "-";
  }
  const date = value instanceof Date ? value : parseDateTime(value);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Etc/GMT-5",
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .reduce<Record<string, string>>((result, part) => {
      result[part.type] = part.value;
      return result;
    }, {});

  return `${parts.day}-${parts.month}-${parts.year} ${parts.hour}:${parts.minute}`;
}

function parseDateTime(value: string): Date {
  const backendDateTime = value.match(
    /^(\d{2}):(\d{2})(?::(\d{2}))?\s+(\d{2})-(\d{2})-(\d{4})$/
  );
  if (backendDateTime) {
    const [, hour, minute, second = "00", day, month, year] = backendDateTime;
    return new Date(
      `${year}-${month}-${day}T${hour}:${minute}:${second}+05:00`
    );
  }

  const backendDate = value.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (backendDate) {
    const [, day, month, year] = backendDate;
    return new Date(`${year}-${month}-${day}T00:00:00+05:00`);
  }

  return new Date(value);
}
